var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.active
    ? _c(
        "div",
        {
          staticClass: "c-alert c-alert--fixed-bottom c-alert--padding-lg",
          class: [_vm.alertClass, _vm.customClass],
          attrs: { id: _vm.alertId },
        },
        [
          _c("div", { staticClass: "c-alert__inner" }, [
            _c("div", { staticClass: "u-space-between u-ai-center u-nm-10" }, [
              _c("div", { staticClass: "u-m-10" }, [
                _c("div", { staticClass: "u-d-f u-ai-center" }, [
                  _c("span", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.text,
                        expression: "text",
                      },
                    ],
                    staticClass: "u-font-16",
                    domProps: { innerHTML: _vm._s(_vm.text) },
                  }),
                  _vm._v(" "),
                  _c("span", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isFormUpdate,
                        expression: "isFormUpdate",
                      },
                    ],
                    staticClass: "u-font-16",
                    domProps: { innerHTML: _vm._s(_vm.formUpdateHtml) },
                  }),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "u-m-10" }, [
                _c(
                  "div",
                  { staticClass: "u-d-f u-ai-center u-flex-wrap u-nm-10" },
                  [
                    _vm.buttons
                      ? _vm._l(_vm.buttons, function (button, index) {
                          return _c(
                            "button",
                            {
                              key: _vm.alertId + "-button-" + index,
                              staticClass:
                                "o-btn o-btn--primary o-btn--rounded-sm u-m-10",
                              attrs: { id: "ca-alert-button-" + index },
                              on: { click: button.callback },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(button.text) +
                                  "\n            "
                              ),
                            ]
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.closable,
                            expression: "closable",
                          },
                        ],
                        staticClass: "o-btn o-btn--icon u-m-10",
                        on: {
                          click: function ($event) {
                            return _vm.exitClick()
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "fal fa-times u-font-150 u-color-white",
                        }),
                      ]
                    ),
                  ],
                  2
                ),
              ]),
            ]),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }